export enum PaymentType {
  CC = 'cc',
  OP = 'op',
}
